<template>
  <view-wrapper name="Import data">
    <div class="mt-16">
      <import-form
        v-if="!validationData"
        :groups="groups"
        :importConfiguration="importConfiguration"
        :allowedToUpload="allowedToUpload"
        :file="file"
        :onFilesAdded="onFilesAdded"
        :validateImport="validateImport"
        :importConfigurations="importConfigurations"
        :importConfigurationChanged="importConfigurationChanged"
        :fileEncodings="fileEncodings"
        :fileEncodingChanged="fileEncodingChanged"
        :fileEncoding="fileEncoding"
        :importName="importName"
        :importNameChanged="importNameChanged"
      ></import-form>

      <validation-data
        v-if="validationData"
        :validationData="validationData"
        :groups="allGroups"
        :goBack="goBack"
        :importData="importData"
      ></validation-data>
    </div>

    <wrapper class="mt-6 text-center">
      <p class="text-base font-medium">
        The import history has moved and is now available from the
        <router-link class="text-highlight" to="/">Dashboard</router-link>
        or by following this link
        <router-link to="importhistory" class="text-highlight"
          >Import History</router-link
        >
      </p>
    </wrapper>

    <modal
      v-if="validationResult.show"
      :type="validationResult.type"
      :heading="validationResult.heading"
      :description="validationResult.description"
      @close="validationResult.show = false"
    >
      <template slot="buttons">
        <grafokett-button
          class="mb-2 button big primary white"
          @click="validationResult.show = false"
          >Close</grafokett-button
        >
      </template>
    </modal>
    <modal
      v-if="importResult.show"
      :type="importResult.type"
      :heading="importResult.heading"
      :description="importResult.description"
      @close="importResult.show = false"
    >
      <template slot="buttons">
        <AuthorizationZone allowAny="AccountType:Administrator">
          <grafokett-button
            v-show="importResult.type === 'success'"
            class="mb-2 button big primary white"
            @click="gotoView('home')"
            >Go to dashboard</grafokett-button
          >
        </AuthorizationZone>
        <AuthorizationZone
          allowAny="AccountType:Administrator"
          :inverted="true"
        >
          <grafokett-button
            v-show="importResult.type === 'success'"
            class="mb-2 button big primary white"
            @click="gotoView('home')"
            >Go to dashboard</grafokett-button
          >
        </AuthorizationZone>
        <grafokett-button
          class="mb-2 button big primary white"
          @click="importResult.show = false"
          >Close</grafokett-button
        >
      </template>
    </modal>
    <LoadingWithProgressBar
      v-if="processInfo && processInfo.heading"
      :heading="processInfo.heading"
      :description="processInfo.description"
      :contentProgress="processInfo.progress"
      :indeterminateProgress="processInfo.indeterminateProgress"
      @close="processInfo = null"
    />
  </view-wrapper>
</template>

<script>
import GrafokettButton from "../../components/forms/Button";
import AuthorizationZone from "../../components/AuthorizationZone";
import Modal from "../../components/Modal";
import ImportForm from "../../components/ImportForm.vue";
import ValidationData from "../../components/ValidationData.vue";
import Wrapper from "../../components/Wrapper.vue";
import LoadingWithProgressBar from "../../components/LoadingWithProgressBar.vue";

export default {
  name: "preferences",
  components: {
    GrafokettButton,
    AuthorizationZone,
    ImportForm,
    Modal,
    ValidationData,
    Wrapper,
    LoadingWithProgressBar,
  },
  data() {
    return {
      groups: null,
      allGroups: null,
      file: null,
      fileEncoding: null,
      importConfiguration: null,
      importConfigurations: null,
      importName: "",
      userAccountTypes: [],
      userId: null,
      processInfo: null,
      validationData: null,
      fileEncodings: null,
      validationResult: {
        show: false,
        type: "error",
        heading: "Error",
      },
      importResult: {
        show: false,
        type: "success",
        heading: "Success",
        description:
          "Your data have been queued for import and will shortly be available",
      },
      pageSize: 500,
    };
  },
  computed: {
    allowedToUpload() {
      return (
        (this.groups && this.groups.length != 0) ||
        this.userAccountTypes.find(x => x === "Administrator")
      );
    },
  },
  methods: {
    importConfigurationChanged(importConfiguration) {
      this.importConfiguration = importConfiguration;
    },
    async getData() {
      await this.$store.dispatch("GROUPS/GET_AVAILABLE_GROUPS");

      const { data } = await this.$store.$api.get("/api/importconfigurations");

      this.importConfigurations = data.data;

      this.importConfiguration = this.importConfigurations.find(x => x.default);

      const { data: fileEncodingsData } = await this.$store.$api.get(
        "/api/importconfigurations/encodings"
      );

      this.fileEncodings = fileEncodingsData.data.map(x => ({ name: x }));
      this.fileEncoding = this.fileEncodings[0];

      const account = this.$store.getters["AUTH/AUTH_GET_USER"];

      this.importName = `Import by ${account.firstname} ${
        account.lastname
      } | ${new Date().toLocaleDateString()}`;
      this.userAccountTypes = account.UserRole;
      this.userId = account.UserId;

      const groups = this.$store.getters["GROUPS/GROUPS"];
      this.allGroups = groups;
      const flattened = this.flattenGroups(groups, []).flatMap(g => g);
      this.groups =
        flattened &&
        flattened.filter(
          g =>
            g.groupSettings &&
            g.groupSettings.allowOrderImportToThisGroup === true
        );
    },
    flattenGroups(groups) {
      return groups.flatMap(g => this.flattenGroup(g, null));
    },
    flattenGroup(group, parentGroup) {
      var sub =
        group.children && group.children.map(c => this.flattenGroup(c, group));
      return [
        {
          ...group,
          parentName: parentGroup && parentGroup.groupName,
          selected: false,
        },
      ].concat(sub);
    },
    onFilesAdded(file) {
      this.file = file;
    },
    fileEncodingChanged(fileEncoding) {
      this.fileEncoding = fileEncoding;
    },
    importNameChanged(importName) {
      this.importName = importName;
    },
    async validateImport(importOptions) {
      this.processInfo = {
        heading: "Validation in progress",
        description: `Validation import file ${this.file.name}`,
        indeterminateProgress: true,
      };

      const formData = new FormData();
      formData.append("file", this.file);
      formData.append(
        "fileEncoding",
        (this.fileEncoding && this.fileEncoding.name) || "CodePage1252"
      );
      formData.append(
        "targetGroups",
        this.groups.filter(g => g.selected === true).map(g => g.id)
      );

      formData.append("importConfigurationId", this.importConfiguration.id);

      for (let importOption in importOptions) {
        formData.append(importOption, importOptions[importOption]);
      }

      try {
        const { data: validationData } = await this.$store.$api.post(
          "/api/import/validate",
          formData,
          {
            headers: {
              "Content-Type": `multipart/form-data; boundary=${
                formData._boundary
              }`,
            },
          }
        );
        const importOk = validationData && validationData.validImportData;
        if (!importOk) {
          this.validationResult.description = validationData.errorReason;
          this.validationResult.show = true;
        } else {
          this.validationData = validationData;
        }
      } catch (error) {
        throw error;
      } finally {
        this.processInfo = null;
      }
    },
    async importData() {
      this.loading = true;
      this.processInfo = {
        heading: "Import in progress",
        description: "Uploading import file",
        progress: 1,
        indeterminateProgress: false,
      };

      try {
        const importType =
          this.validationData.orders && this.validationData.usesOrders
            ? "orders"
            : "articles";

        const totalArticlePages =
          this.validationData.articles && this.validationData.articles.length
            ? Math.ceil(this.validationData.articles.length / this.pageSize)
            : 0;

        const totalOrderPages =
          this.validationData.orders && this.validationData.orders.length
            ? Math.ceil(this.validationData.orders.length / this.pageSize)
            : 0;

        const totalPages =
          (totalArticlePages > totalOrderPages
            ? totalArticlePages
            : totalOrderPages) + 1;

        const formData = new FormData();
        formData.append("file", this.file);
        formData.append("fileName", this.file.name);
        formData.append("importName", this.importName);

        const { data: importInitialData } = await this.$store.$api.post(
          "/api/import/importInitialData",
          formData,
          {
            headers: {
              "Content-Type": `multipart/form-data; boundary=${
                formData._boundary
              }`,
            },
          }
        );

        this.processInfo.progress = Math.round((1 / totalPages) * 100);

        if (importInitialData.entityId) {
          this.processInfo.description = `Creating ${importType}`;

          const importArticlesAndOrdersResult = await this.importArticlesAndOrders(
            1,
            importInitialData,
            totalPages
          );

          if (importArticlesAndOrdersResult.validImportData) {
            this.file = null;
            this.validationData = null;
          } else {
            this.importResult.type = "error";
            this.importResult.heading = "Error";
            this.importResult.description = `Something went wrong with importing ${importType} data. Please verify file formatting and try again`;
          }
        } else {
          this.importResult.type = "error";
          this.importResult.heading = "Error";
          this.importResult.description =
            "Something went wrong with importing the initial data. Please verify file formatting and try again.";
        }
      } catch (e) {
        this.importResult.type = "error";
        this.importResult.heading = "Error";
        this.importResult.description =
          "Something went wrong with importing your data s. Please verify file formatting";
        console.error(e);
      } finally {
        this.importResult.show = true;
        this.loading = false;
      }
      this.processInfo = null;
    },
    async importArticlesAndOrders(page, importProcess, totalPages) {
      const articlesPaginated =
        this.validationData.articles && this.validationData.articles.length
          ? this.validationData.articles.slice(
              (page - 1) * this.pageSize,
              page * this.pageSize
            )
          : [];

      const ordersPaginated =
        this.validationData.orders && this.validationData.orders.length
          ? this.validationData.orders.slice(
              (page - 1) * this.pageSize,
              page * this.pageSize
            )
          : [];

      if (articlesPaginated.length || ordersPaginated.length) {
        const objArticlesAndOrders = {
          usesOrders: this.validationData.usesOrders,
          articles: articlesPaginated,
          orders: ordersPaginated,
          importId: importProcess.entityId,
          organizationId: importProcess.organizationId,
          userId: importProcess.userId,
          importDataId: importProcess.importDataId,
        };

        const { data: importDataResult } = await this.$store.$api.post(
          "/api/import/importArticlesAndOrders",
          objArticlesAndOrders
        );

        this.processInfo.progress = Math.round(((page + 1) / totalPages) * 100);

        if (importDataResult.validImportData)
          await this.importArticlesAndOrders(
            page + 1,
            importProcess,
            totalPages
          );

        return importDataResult;
      }
    },
    gotoView(view) {
      this.$router.push(`/${view}`);
    },
    goBack() {
      this.validationData = null;
    },
  },
  async beforeMount() {
    await this.getData();
  },
};
</script>
